import React from "react";
import Image1920x156 from "../img/thumb/photo-1920x156--2.jpg";
import {Config} from "../Config";
import * as Utils from "../inc/Utils";

export default function ExpertsReport(prop) {

    let [data, setData] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const resView = await getExpertsReport();

                if(prop !== null && prop.lang === 'en') {
                    resView.title = resView.title_en;
                    resView.detail = resView.detail_en;
                }

                setData(resView);
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getExpertsReport() {
        const response = await fetch(Config.apiUrl +'expertsReport/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                <img src={Image1920x156} alt="" />
                <div className="container">
                    <p data-aos="fade-in"><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a> / {prop.lang === 'en' ? 'Experts':'ผู้เชี่ยวชาญ'} / {prop.lang === 'en' ? 'Experts Report':'สถิติที่เกี่ยวข้อง'}</p>
                    <h1 className="h2 textrow">
                        <span data-aos="fade-in">{prop.lang === 'en' ? 'Experts Report':'สถิติที่เกี่ยวข้อง'}</span>
                    </h1>
                </div>
            </div>

            <div className="section">
                <div className="container">
                    <h2 className="title-line-left fs-28 textrow mt-2">
                        <span data-aos="fade-right">{Utils.cleanOutput(data?.title)}</span>
                    </h2>
                    <div className="article pt-2 pt-sm-3" style={{"--color":"#5D5D5D"}} data-aos="fade-in">
                        <div dangerouslySetInnerHTML={{__html: data?.detail}}></div>

                        {
                            data?.embed ?
                                <div className="mt-5">
                                    <div className="iframe-wrapper">
                                        <div className="iframe-container">
                                            <div dangerouslySetInnerHTML={{__html: data?.embed}}></div>
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }

                        {
                            data?.embed2 ?
                                <div className="mt-5">
                                    <div className="iframe-wrapper">
                                        <div className="iframe-container">
                                            <div dangerouslySetInnerHTML={{__html: data?.embed2}}></div>
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }

                        {
                            data?.embed3 ?
                                <div className="mt-5">
                                    <div className="iframe-wrapper">
                                        <div className="iframe-container">
                                            <div dangerouslySetInnerHTML={{__html: data?.embed3}}></div>
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }

                        {
                            data?.embed4 ?
                                <div className="mt-5">
                                    <div className="iframe-wrapper">
                                        <div className="iframe-container">
                                            <div dangerouslySetInnerHTML={{__html: data?.embed4}}></div>
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }

                        {
                            data?.embed5 ?
                                <div className="mt-5">
                                    <h3 className="mt-5 mb-2">{prop.lang === 'en' ? 'Relevant statistics':'สถิติที่เกี่ยวข้อง'}</h3>
                                    <div className="iframe-wrapper">
                                        <div className="iframe-container">
                                            <div dangerouslySetInnerHTML={{__html: data?.embed5}}></div>
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }
                    </div>
                </div>
            </div>
        </>
    );
} 